import { RootState, SetState } from '@/store/useStore.ts';
import {
  SessionSlice,
  UserSessionContextPayload,
  UserSessionErrorPayload,
  UserSessionStoreParts,
} from '@/store/slices/session/types';
import { emptySliceError } from '@/store/slices/sliceError';
import { SessionJWT } from '@/utilities/getters/types';

export const defaultSessionContext = {
  authToken: { jwt: '', created: null, expires: null } as SessionJWT,
  loginToken: { jwt: '', created: null, expires: null } as SessionJWT,
  hasActiveSession: false,
  userId: null,
  sessionId: null,
  region: null,
  sessionStartTime: null,
  mfa: null,
  wasOnline: false,
  timezone: null,
  created: null,
};
const defaults = {
  userSessionContext: defaultSessionContext,
  sessionError: emptySliceError(),
};

export const sessionSlice = ({ set }: SetState<RootState>): SessionSlice => ({
  sessionResetRevision: 0,
  userSessionContext: { ...defaults.userSessionContext },
  userSessionError: { ...defaults.sessionError },
  setUserSessionContext: (newState: UserSessionContextPayload) =>
    set(
      (state: RootState) => {
        const ctx = JSON.parse(JSON.stringify(newState));
        return {
          ...state,
          userSessionContext: {
            ...state.userSessionContext,
            ...ctx,
          },
        };
      },
      false,
      'userSession/setUserSessionContext',
    ),

  setUserSessionError: (newState: UserSessionErrorPayload) =>
    set(
      (state: RootState) => {
        return {
          ...state,
          userSessionError: {
            ...state.userSessionError,
            ...newState,
          },
        };
      },
      false,
      'userSession/setUserSessionError',
    ),
  resetUserSessionPart: (part: UserSessionStoreParts) =>
    set(
      (state) => {
        if (part === UserSessionStoreParts.sessionError) {
          return {
            ...state,
            userSessionError: { ...defaults.sessionError },
            sessionResetRevision: state.sessionResetRevision + 1,
          };
        }
        if (part === UserSessionStoreParts.userSessionContext) {
          return {
            ...state,
            userSessionContext: { ...defaults.userSessionContext },
            sessionResetRevision: state.sessionResetRevision + 1,
          };
        }
        return state;
      },
      false,
      `userSession/reset/${part}`,
    ),

  resetAllUserSessionParts: () =>
    set(
      (state) => ({
        ...state,
        userSessionContext: { ...defaults.userSessionContext },
        userSessionError: { ...defaults.sessionError },
        sessionResetRevision: state.sessionResetRevision + 1,
      }),
      false,
      'userSession/resetUserSession',
    ),
});
